import { render, staticRenderFns } from "./successDetail.vue?vue&type=template&id=7b2e932d&scoped=true"
import script from "./successDetail.vue?vue&type=script&lang=js"
export * from "./successDetail.vue?vue&type=script&lang=js"
import style0 from "./successDetail.vue?vue&type=style&index=0&id=7b2e932d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2e932d",
  null
  
)

export default component.exports